import isString from 'lodash-es/isString';

import { AtiraLink } from '../../../model/atira-link/AtiraLink';
import { CreateAtiraLinkDto } from '../../../model/atira-link/dto/CreateAtiraLinkDto';
import { EditAtiraLinkDto } from '../../../model/atira-link/dto/EditAtiraLinkDto';
import { getMediaUrl } from '../../../utils/Media';

type AtiraLinkType =
  | AtiraLink
  | Partial<AtiraLink>
  | CreateAtiraLinkDto
  | EditAtiraLinkDto;

export const getLinkImage = (atiraLink: AtiraLinkType) => {
  if ((atiraLink as AtiraLink & { fake: boolean })?.fake === true) {
    return atiraLink?.image as string;
  }

  if (isString(atiraLink?.image)) {
    return getMediaUrl(atiraLink?.image!);
  }

  if (atiraLink?.image) {
    return URL.createObjectURL(atiraLink?.image! as any);
  }

  return '';
};
